/**
 * MIKE — Maiores Altas e Baixas com a Média HLC.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLBands.cs, classe
 * FML.MIKE). OVERLAY de preço (o `PlotInNewAxis` está comentado no engine),
 * 6 linhas de suporte/resistência sobre o preço típico:
 *
 *   TYP = (H + L + C) / 3
 *   LL  = LLV(L, N)          HH = HHV(H, N)
 *   WR  = TYP + (TYP − LL)   MR = TYP + (HH − LL)   SR = 2·HH − LL
 *   WS  = TYP − (HH − TYP)   MS = TYP − (HH − LL)   SS = 2·LL − HH
 *
 * Pacote na ordem [WR, MR, SR, WS, MS, SS] — é essa ordem que define a cor
 * default de cada linha (paleta por índice do engine). Paridade provada em
 * __tests__/mike.silverlight.test.js.
 */
import { add, sub, mul, div, hhv, llv } from "./silverlightDsl";
import { MIKE as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const high = data.map((d) => num(d.high));
    const low = data.map((d) => num(d.low));
    const close = data.map((d) => num(d.close));

    const typ = div(add(add(high, low), close), 3);
    const ll = llv(low, period);
    const hh = hhv(high, period);

    const wr = add(typ, sub(typ, ll));
    const mr = add(typ, sub(hh, ll));
    const sr = sub(mul(hh, 2), ll);
    const ws = sub(typ, sub(hh, typ));
    const ms = sub(typ, sub(hh, ll));
    const ss = sub(mul(ll, 2), hh);

    const out = (arr, i) => (Number.isFinite(arr[i]) ? arr[i] : undefined);

    return wr.map((_, i) => {
      const v = {
        wr: out(wr, i),
        mr: out(mr, i),
        sr: out(sr, i),
        ws: out(ws, i),
        ms: out(ms, i),
        ss: out(ss, i),
      };
      return Object.values(v).every((x) => x === undefined) ? undefined : v;
    });
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    return Math.max(0, period - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
